import * as React from 'react';

import Icon from '@ant-design/icons/lib/components/Icon';

const ICar = (props: any) => {
    return (
        <Icon
            component={() => {
                return (
                    <svg
                    width="22"
                    height="20"
                    viewBox="0 0 22 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.11296 16.8809V18.4365C3.11296 18.7009 3.02422 18.9225 2.84675 19.1013C2.66907 19.2803 2.44899 19.3698 2.18649 19.3698H1.42647C1.16397 19.3698 0.943985 19.2803 0.766515 19.1013C0.588838 18.9225 0.5 18.7009 0.5 18.4365V8.88784L3.02278 1.63646C3.11481 1.35086 3.28353 1.12395 3.52894 0.955747C3.77435 0.787332 4.04756 0.703125 4.34856 0.703125H17.699C17.9881 0.703125 18.2506 0.788681 18.4865 0.959792C18.7222 1.1309 18.8858 1.35646 18.9772 1.63646L21.5 8.88784V18.4365C21.5 18.7009 21.4112 18.9225 21.2335 19.1013C21.056 19.2803 20.836 19.3698 20.5735 19.3698H19.8135C19.551 19.3698 19.3309 19.2803 19.1532 19.1013C18.9758 18.9225 18.887 18.7009 18.887 18.4365V16.8809H3.11296ZM3.10369 7.02117H18.8963L17.338 2.56979H4.66201L3.10369 7.02117ZM5.3964 13.5785C5.84584 13.5785 6.22703 13.4199 6.53997 13.1028C6.85271 12.7859 7.00907 12.401 7.00907 11.9482C7.00907 11.4955 6.85178 11.1115 6.53719 10.7962C6.2224 10.4811 5.84028 10.3236 5.39084 10.3236C4.9414 10.3236 4.56031 10.4821 4.24757 10.799C3.93463 11.1161 3.77816 11.5011 3.77816 11.9538C3.77816 12.4066 3.93556 12.7905 4.25035 13.1056C4.56494 13.4208 4.94696 13.5785 5.3964 13.5785ZM16.6092 13.5785C17.0586 13.5785 17.4397 13.4199 17.7524 13.1028C18.0654 12.7859 18.2218 12.401 18.2218 11.9482C18.2218 11.4955 18.0644 11.1115 17.7496 10.7962C17.4351 10.4811 17.053 10.3236 16.6036 10.3236C16.1542 10.3236 15.773 10.4821 15.46 10.799C15.1473 11.1161 14.9909 11.5011 14.9909 11.9538C14.9909 12.4066 15.1482 12.7905 15.4628 13.1056C15.7776 13.4208 16.1597 13.5785 16.6092 13.5785ZM2.35294 15.0142H19.6471V8.88784H2.35294V15.0142Z"
                      fill="#AEA9B1"
                    />
                  </svg>
                );
            }}
            {...props}
        />
    );
};

export default ICar;
